import { Grid, Stack } from "@vividtheory/minerva-lab";
import { isEqual } from "lodash";
import React, { useState } from "react";
import { AvatarGroup, CellItem, Radio, Typography, UserAvatar, } from "../components";
import { CompanyAvatar } from "../components/CompanyAvatar";
import { SubmittingButton } from "../components/SubmittingButton";
import { LoginOrganizationSelectFormModal } from "./LoginOrganizationSelectFormModal";
export const LoginOrganizationSelectForm = ({ isModal = false, user, organizations, onSelect, loading, subTitle = "Select the organization you want to log into.", secondIconImg, }) => {
    //TODO: currently there is no defualt selected organization
    const [orgId, setOrgId] = useState("");
    return isModal ? (React.createElement(LoginOrganizationSelectFormModal, { user: user, organizations: organizations, onSelect: onSelect, loading: loading, subTitle: subTitle, secondIconImg: secondIconImg })) : (React.createElement(Stack, { width: "100%", gap: 4, sx: {
            breakpoints: {
                md: {
                    padding: 4,
                },
            },
        } },
        React.createElement(Grid, { container: true, gap: 2, alignItems: "center" },
            React.createElement(UserAvatar, { src: user.img, alt: `${user.firstName} ${user.lastName}`, size: "sm" }),
            React.createElement(Grid, { item: true, xs: true },
                React.createElement(Typography, { textTransform: "capitalize", variant: "h5", fontWeight: "bold" },
                    "Hello ",
                    user.firstName,
                    ", Welcome Back!"))),
        React.createElement(Typography, { variant: "body1", fontWeight: "regular", textColor: "disabled.onContainer" }, subTitle),
        React.createElement(Stack, { width: "100%", gap: 1, sx: { padding: 2 } }, organizations.map((org) => (React.createElement(CellItem, { key: org.id, title: org.name, density: "dense", startNode: React.createElement(AvatarGroup, { size: "xxs" },
                React.createElement(CompanyAvatar, { src: org.img, size: "xxs", alt: org.name }),
                secondIconImg && (React.createElement(CompanyAvatar, { src: secondIconImg, size: "xxs", alt: org.name }))), endNode: React.createElement(Radio, { as: "div", checked: isEqual(orgId, org.id), sx: {
                    "&:hover": {
                        borderColor: (theme) => theme.palette.outline,
                    },
                } }), onClick: () => setOrgId(org.id) })))),
        React.createElement(SubmittingButton, { type: "checking", fullWidth: true, loading: loading, onClick: () => onSelect(orgId), disabled: orgId === "" }, "Continue")));
};
//# sourceMappingURL=LoginOrganizationSelectForm.js.map